import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccessResult, NO_ACCESS_MESSAGE } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

const useCanCreatePluginTemplates = (): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);

  return useMemo(() => {
    if (viewer.admin) {
      return { result: true };
    }

    return { result: false, message: NO_ACCESS_MESSAGE };
  }, [viewer]);
};

export default useCanCreatePluginTemplates;
